import { Routes, Route, useLocation } from 'react-router-dom';
import TopBar from './components/TopBar';
import ProtectedRoute from './components/ProtectedRoute';
import UpdatePrompt from './components/UpdatePrompt';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ResetPassword from './pages/ResetPassword';
import SalesHub from './pages/SalesHub';
import Dashboard from './pages/Dashboard';
import Pipeline from './pages/Pipeline';
import ApolloImport from './pages/ApolloImport';
import Reports from './pages/Reports';
import Profile from './pages/Profile';
import Users from './pages/Users';
import ContentEditor from './pages/ContentEditor';
import { useAuth } from './hooks/useAuth';

export default function App() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const showTopBar = user && pathname !== '/reset-password';
  return (
    <div className="min-h-screen flex flex-col">
      {showTopBar && <TopBar />}
      <UpdatePrompt />
      <main className="flex-1">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/"               element={<ProtectedRoute><SalesHub /></ProtectedRoute>} />
          <Route path="/pipeline"       element={<ProtectedRoute><Pipeline /></ProtectedRoute>} />
          <Route path="/import/apollo"  element={<ProtectedRoute><ApolloImport /></ProtectedRoute>} />
          <Route path="/dashboard"      element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/reports"        element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/profile"        element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/users"          element={<ProtectedRoute requireAdmin><Users /></ProtectedRoute>} />
          <Route path="/admin"          element={<ProtectedRoute requireAdmin><ContentEditor /></ProtectedRoute>} />
        </Routes>
      </main>
    </div>
  );
}
